import { ObjectValues } from '$shared/helpers';

export const ACCOUNT_TYPE = {
  individual: 'individual',
  enterprise: 'enterprise',
  federated: 'federated',
} as const;

export type AccountType = ObjectValues<typeof ACCOUNT_TYPE>;
